import type { TFunction } from 'i18next'

import { formatShipmentStatus } from './format'

/*
 * Console twin of the product's `shipmentStatusLabel`.
 *
 * The product builds its labels from the per-stage filter maps in
 * `order-statuses.ts` / `quote-statuses.ts`, which the console carries in an
 * older shape (its Mark As keys). Syncing those would move every Mark As label
 * in the console, so this keeps the product's signature and its three renames —
 * the words a user reads on the tab that lists the status — and formats the
 * rest the way the product's own fallback does.
 */
const PRODUCT_WORDS: Readonly<Record<string, string>> = {
  ongoing: 'Active',
  upcoming: 'Scheduled',
  on_hold: 'Hold',
}

export function shipmentStatusLabel(status: string | null | undefined, _t: TFunction): string {
  if (!status) return ''
  return PRODUCT_WORDS[status] ?? formatShipmentStatus(status)
}
